import { Grid, IconButton, Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import './ord-prd.component.scss';
import { formatDate, formatTo0Decimal, formatToNumber, formatToNumberRound, isEmptyArray, isNull } from '../../common/util.services';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrderProducts, getProductOrders } from '../../order/order.services';
import { HelpOutline } from '@mui/icons-material';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';

const OrdPrdComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const navigate = useNavigate();
  const params = useParams();
  const rows: GridRowsProp = [];
  const [products, setProducts] = useState(rows);
  const [loading, setLoading] = useState(true);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [title, setTitle] = useState('');
  
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, width: 110, editable: false },
    { field: 'costingCode', headerName: 'Cost Code', filterable: false, editable: false, sortable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openCostingPage(params.row) }}>{params.row.costingCode}</div>}
    },
    { field: 'description', headerName: 'Description', filterable: false, editable: false, sortable: false, width: 160,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.enqProductId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.description}</Stack>)
    },
    { field: 'orderCode', headerName: 'Order Code', filterable: false, editable: false, sortable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openOrderPage(params.row) }}>{params.row.orderCode}</div>}
    },
    { 
      field: 'inputCost', headerName: 'I/P Cost', filterable: false, editable: false, sortable: false, width: 75,
      valueFormatter: (inputCost: any) => formatToNumberRound(inputCost)
    },
    { 
      field: 'totalCost', headerName: 'Price/Pack', filterable: false, editable: false, sortable: false, width: 90,
      valueFormatter: (totalCost: any) => formatToNumberRound(totalCost)
    },
    { field: 'uom', headerName: 'UOM', filterable: false, editable: false, sortable: false, width: 70 },
    {
      field: 'pack', headerName: 'Pc/Pack', filterable: false, sortable: false, width: 70, editable: false,
      valueFormatter: (value: any) => 0 === value ? 'NA' : value
    },
    {
      field: 'quantity', headerName: 'Qty', filterable: false, sortable: false, width: 60, editable: false,
      valueFormatter: (quantity: any) => formatToNumber(quantity)
    },
    {
      field: 'value', headerName: 'Price', filterable: false, sortable: false, width: 85, editable: false,
      valueFormatter: (value: any) => formatTo0Decimal(value)
    },
    {
      field: 'poValue', headerName: 'PO Value', filterable: false, sortable: false, width: 85, editable: false,
      valueFormatter: (poValue: any) => formatTo0Decimal(poValue)
    },
    { field: 'scheduleCode', headerName: 'Schedule', filterable: false, editable: false, sortable: false, width: 90,
      renderCell: (params) => { return <div className={isNull(params.row.scheduleCode) ? "" : "cell-link"}
      onClick={() => { openSchedulePage(params.row) }}>{isNull(params.row.scheduleCode) ? 'NA' : params.row.scheduleCode}</div> }
    },
    { field: 'dispatchDate', headerName: 'LFH Target', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (dispatchDate: any) => formatDate(dispatchDate)
    },
    { field: 'orderRemarks', headerName: 'Remarks', filterable: false, sortable: false, width: 100, editable: false}
  ];

  useEffect(() => {
    if (isEmptyArray(rows)) {
      if(isNull(params.enqPrdId)) {
        getOrderProducts(params.orderId, appContext,
          (response: any) => {
            setProducts(response.data);
            setTitle('Products For Order');
            appContext.setShowLoader(false);
            setLoading(false);
          }, (error: any) => {
            console.log(error);
            appContext.setShowLoader(false);
            setLoading(false);
          });
      } else {
        getProductOrders(params.enqPrdId, appContext,
          (response: any) => {
            setProducts(response.data);
            setTitle('Orders For Product');
            appContext.setShowLoader(false);
            setLoading(false);
          }, (error: any) => {
            console.log(error);
            appContext.setShowLoader(false);
            setLoading(false);
          });
        setLoading(false);
      }
    }
  }, []);

  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = products.filter((row: any) =>
      selectedIds.has(row.rowId)
    );
    setSelectedRows(selectedRowData);
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const addSchedule = () => {
    if(selectedRows.length <= 0) {
      appContext.setDialogMessage('Select a product to add schedule.');
    } else if (!isNull(selectedRows[0].scheduleCode)) {
      appContext.setDialogMessage('Selected product already has a schedule.');
    } else {
      navigate("/production/schedule/new", {state: {orderId: selectedRows[0].orderId, product: selectedRows[0]}});
    }
  }

  const openSchedulePage = (row: any) => {
    if(!isNull(row.scheduleCode)) {
      navigate("/production/schedule/" + row.scheduleId, {state: {orderId: row.orderId, product: ""}});
    }
  }

  const openOrderPage = (row: any) => {
    navigate('/enquiry/order/' + row.orderId, {state: {enquiryCode: "", customer: "", product: "", description: "", type: ""}})
  }

  const openCostingPage = (row: any) => {
    navigate("/costing/list/" + row.costingId, {state: {orderId: params.orderId, product: selectedRows[0], setQty: row.pack}});
  }

  return (
    <div>
      <Grid container spacing={1}>
        <IGridComponent title={title} rows={products} columns={columns} getRowId={(row: any) => row.rowId}
          apiRef={props.apiRef} showAction={false} showEditAction={false} showAddBtn={false} loading={loading}
          showApproveAction={false} showAddAction={false} showDownAction={false} showUpAction={false} maxWidth={1460}
          hideFooterPagination={true} showDeleteAction={false} showExtBtn={true} extBtnAction={addSchedule} extBtnText={'Add Schedule'}
          checkboxSelection={true} disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange}
          disableMultipleRowSelection={true}/>
        <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
          dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
      </Grid>
    </div>
  );
}

export default OrdPrdComponent;
